import { http } from '../client';
import type { CallOptions, WriteOptions } from '../types';
import type { DnsApi } from './dns';

// Paths mirror subsystems/dns/facade/adapters/admin-api/src/admin/dns.rs.
const seg = encodeURIComponent;
const rd = (o?: CallOptions) => ({ signal: o?.signal });
const wr = (o?: WriteOptions) => ({ signal: o?.signal, idempotencyKey: o?.idempotencyKey, notifyCustomer: o?.notifyCustomer });

export const dnsHttp: DnsApi = {
  findDnsZone: (domain, customerId, opts) => http.get('api', '/dns/zones', { query: { domain, customer_id: customerId }, ...rd(opts) }),
  getDnsZone: (id, opts) => http.get('api', `/dns/zones/${seg(id)}`, rd(opts)),
  getDnsZoneVersion: (id, version, opts) => http.get('api', `/dns/zones/${seg(id)}/versions/${version}`, rd(opts)),
  editDnsRecords: (id, body, opts) => http.patch('api', `/dns/zones/${seg(id)}/records`, body, wr(opts)),
  rollbackDnsZone: (id, body, opts) => http.post('api', `/dns/zones/${seg(id)}/rollback`, body, wr(opts)),
  exportDnsZone: (id, opts) => http.get('api', `/dns/zones/${seg(id)}/export`, rd(opts)),
  importDnsZone: (id, body, opts) => http.post('api', `/dns/zones/${seg(id)}/import`, body, wr(opts)),
  listDnsTemplates: (opts) => http.get('api', '/dns/templates', rd(opts)),
  applyDnsTemplate: (id, body, opts) => http.post('api', `/dns/zones/${seg(id)}/template`, body, wr(opts)),
  setDnsLogin: (id, body, opts) => http.put('api', `/dns/zones/${seg(id)}/login`, body, wr(opts)),
  revokeDnsLogin: (id, body, opts) => http.post('api', `/dns/zones/${seg(id)}/login/revoke`, body, wr(opts)),
};
